import { ListColumn, ListDataColumn } from "../ListColumn";
import { MedicinalProductsListView } from "./MedicinalProductsListView";

export class AttachmentEntityListView extends MedicinalProductsListView {

        constructor(items: any) {

            const itemFinderArrayColumns=[
                new ListColumn("Num", ListDataColumn.TEXT, "num"),
                new ListColumn("EV Code", ListDataColumn.TEXT, "ev_Code"),
                new ListColumn("Attachment Name", ListDataColumn.TEXT, "attachmentname"),
                new ListColumn("Language", ListDataColumn.LOOKUP, "languagecode", "language"),
                new ListColumn("Type", ListDataColumn.LOOKUP, "attachmenttype", "attachmenttype"),
            ];

            const itemFinderTreeColumns=[
                new ListColumn("EV Code", ListDataColumn.TEXT, "ev_Code"),
                new ListColumn("Attachment Name", ListDataColumn.TEXT, "attachmentname"),
                new ListColumn("Language", ListDataColumn.LOOKUP, "languagecode", "language"),
                new ListColumn("Type", ListDataColumn.LOOKUP, "attachmenttype", "attachmenttype"),
            ];

            super(items,itemFinderArrayColumns,itemFinderTreeColumns);


    }

}